var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4653 21.1479H21.3499M8.6499 21.1479L12.2043 20.4317C12.393 20.3937 12.5662 20.3008 12.7023 20.1646L20.6591 12.2035C21.0406 11.8218 21.0403 11.203 20.6585 10.8217L18.973 9.13804C18.5913 8.75682 17.9729 8.75708 17.5916 9.13862L9.63396 17.1006C9.49816 17.2365 9.40543 17.4094 9.36738 17.5977L8.6499 21.1479Z",
    stroke: "#898E99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.7ba21298cd1d72fa1062c0be1031c8b1.svg";
export { ForwardRef as ReactComponent };